import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';

import classnames from "classnames";

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";
import PaginationComponent from '../../variables/PaginationComponent.js'; // Pagination 컴포넌트 임포트

import '../../assets/css/Board.css'

// reactstrap components
import {
  Table,
  Input,
  InputGroupText,
  InputGroup,
  Button,
} from "reactstrap";

import {
  Link
} from "react-router-dom";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownZA } from "@fortawesome/free-solid-svg-icons"
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"

export default function UserList() {

  const [isLoading, setIsLoading] = useState(true);

  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [column, setColumn] = useState('created_at');
  const [direction, setDirection] = useState('desc');

  const [dateIsOn, setDateIsOn] = useState(true);
  const [dateIsDesc, setDateIsDesc] = useState(false);
  const [nameIsOn, setNameIsOn] = useState(false);
  const [nameIsDesc, setNameIsDesc] = useState(false);
  const [roleIsOn, setRoleIsOn] = useState(false);
  const [roleIsDesc, setRoleIsDesc] = useState(false);

  /* 최초 자료실 접근 시 로그인 권한 확인 */
  useEffect(() => {
    
    // 서버에서 게시글 데이터 가져오는 로직
    async function selectUserList() {
      //로딩중 표기
      setIsLoading(true);

      await axios.get(`/profile/getUserList?page=${currentPage}&column=${column}&direction=${direction}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      })
      .then((response) => {
        const data = response.data;

        //console.log("Posts Return : " + JSON.stringify(data.results));

        setPosts(data.results);
        setTotalPages(data.totalPages);
        //console.log(posts);
          
        // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('게시글 목록 조회 오류:', error);
      });
    }

    // 접근권한 확인을 위한 get-session 이후 실행(1초)
    setTimeout(() => {
      selectUserList();
    }, 10); // 시간을 밀리초 단위로 설정 (1초 = 1000 밀리초)
  }, [currentPage]);

  /* 게시판 정렬 소스 Start */
  useEffect(() => {
    setTimeout(() => {

    // 정렬에 따른 date / name color 세팅
    var dateElements = document.getElementsByName("dateDirection");
    var dateColor;

    dateIsOn === true ? dateColor = "white" : dateColor = "grey";
    
    for (var i = 0; i < dateElements.length; i++){
      dateElements[i].style.color = dateColor;
    }

    var nameElements = document.getElementsByName("nameDirection");
    var nameColor;

    nameIsOn === true ? nameColor = "white" : nameColor = "grey";

    for (var j = 0; j < nameElements.length; j++){
      nameElements[j].style.color = nameColor;
    }

    var roleElements = document.getElementsByName("roleDirection");
    var roleColor;

    roleIsOn === true ? roleColor = "white" : roleColor = "grey";

    for (var z = 0; z < roleElements.length; z++){
      roleElements[z].style.color = roleColor;
    }

    // 자료실 접근 시 이중호출로 인하여 function 분리
    async function selectUserListByOrder() {
      try {
        const response = await axios.get(`/profile/getUserList?page=${currentPage}&column=${column}&direction=${direction}`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });
          const data = response.data;
          //console.log(data.results);
          setPosts(data.results);
          setTotalPages(data.totalPages);
          
      } catch (error) {
        console.error('게시글 목록 정렬 오류:', error);
      }
    }

    selectUserListByOrder();
    
    }, 50);
  }, [dateIsOn, dateIsDesc, nameIsOn, nameIsDesc, roleIsOn, roleIsDesc]);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {

  }, [totalPages])

  const DateOrderToggle = () => {
    setDateIsOn(true);
    setNameIsOn(false);
    setRoleIsOn(false);

    setDateIsDesc(!dateIsDesc);
    setColumn('created_at');
    dateIsDesc === true ? setDirection('desc') : setDirection('asc');
  }
  const NameOrderToggle = () => {
    setDateIsOn(false);
    setNameIsOn(true);
    setRoleIsOn(false);

    setNameIsDesc(!nameIsDesc);
    setColumn('name');
    nameIsDesc === true ? setDirection('desc') : setDirection('asc');
  }
  const RoleOrderToggle = () => {
    setDateIsOn(false);
    setNameIsOn(false);
    setRoleIsOn(true);

    setRoleIsDesc(!roleIsDesc);
    setColumn('role');
    roleIsDesc === true ? setDirection('desc') : setDirection('asc');
  }
  /* 게시판 정렬 소스 END */

  /* 게시판 검색 */
  const [searchText, setSearchText] = useState('');
  const [searchFocus, setSearchFocus] = useState(false);

  // 서버로 검색어를 보내고 검색 결과를 받아오는 함수
  async function searchResults() {
    try {
      const response = await axios.get(`/profile/getUserList?page=1&column=${column}&direction=${direction}&searchText=${searchText}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      });

      const data = response.data;
      console.log(data.results);
      setPosts(data.results);
      setTotalPages(data.totalPages);

    } catch (error) {
      console.error('검색 중 오류 발생: ', error);
    }
  }
  
  // 검색버튼을 누르거나
  const searchClick = () => {
    searchResults();
  }
  // 검색창에서 엔터키를 누르면 수행
  const handleKeyDown = (e) => {
    if (e.key === 'Enter'){
      searchResults();
    }
  }

  return (
    <>
      <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />
            <div id="UserList" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">User Management</div>
                    <div className="SectionHeaderTitle">회원 관리</div>
                    </div>
                </div>
                
                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {/* 게시글 목록 표시 */}
                    {isLoading ? (
                      // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-name'>Loading...</p>
                          </div>
                        </div>
                    ) : (<></>)}
                    <div className="SectionTableContents">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="td-id">No</th>
                              <th className="td-id">회원ID</th>
                              <th className="td-writer">이메일</th>
                              <th>이름&nbsp;&nbsp;
                              {nameIsDesc === true ?
                                <FontAwesomeIcon  name="nameDirection" onClick={ NameOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownAZ} /> :
                                <FontAwesomeIcon  name="nameDirection" onClick={ NameOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownZA} />
                              } 
                              </th>
                              <th className="td-file">핸드폰번호</th>
                              <th className="td-published">권한&nbsp;&nbsp;
                              {roleIsDesc === true ?
                                <FontAwesomeIcon  name="roleDirection" onClick={ RoleOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownAZ} /> :
                                <FontAwesomeIcon  name="roleDirection" onClick={ RoleOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownZA} />
                              } 
                              </th>
                              <th className="td-date">가입일&nbsp;&nbsp;
                              {dateIsDesc === true ?
                                <FontAwesomeIcon name="dateDirection" onClick={ DateOrderToggle } style={{cursor:'pointer', color:'white'}} icon={faArrowDownAZ} /> :
                                <FontAwesomeIcon name="dateDirection" onClick={ DateOrderToggle } style={{cursor:'pointer', color:'white'}} icon={faArrowDownZA} />
                              }
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {posts && posts.map((post, index) => {
                              return(
                                  <tr key={index} id={post.id}>
                                    <td className="td-id">{post.rownum}</td>
                                    <td className="td-id">{post.id}</td>
                                    <td className="td-writer">
                                    <Link to={`/UserUpdate/${post.id}`}>
                                      {post.email}
                                    </Link>
                                    </td>
                                    <td className="td-name">
                                      {post.name}
                                    </td>
                                    <td className="td-published">{post.cellphone}</td>
                                    <td className="td-published">{post.role}</td>
                                    <td className="td-date">{moment(post.created_at, 'YYYY-MM-DD HHmmss').format('YYYY-MM-DD')}</td>
                                  </tr>
                              )
                              })
                            }
                            {posts.length === 0 ? (
                                <tr>
                                  <td colSpan="7">게시글이 없습니다</td>
                                </tr>
                            ):(<></>)}
                          </tbody>
                        </Table>
                    </div>
                    
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />

                    <div className='boardSearchArea'>
                      <InputGroup
                        className={classnames({
                          "input-group-focus": searchFocus,
                        })}
                      >
                        <InputGroupText>
                          <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </InputGroupText>
                        <Input
                          placeholder="Email/이름/핸드폰번호 검색"
                          type="text"
                          id="searchText"
                          name= "searchText"
                          onChange={(e) => setSearchText(e.target.value)}
                          onFocus={(e) => setSearchFocus(true)}
                          onBlur={(e) => setSearchFocus(false)}
                          onKeyDown={handleKeyDown}
                        />
                      </InputGroup>
                      <Button type="text" className="itsBtnDefault boardSearchBtn" size="md" onClick={searchClick}>
                        검색
                      </Button>
                    </div>   
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer/>
    </>
  );
}
